import getMayflyData from '../graphql/getMayflyData'
import { log } from './error-tracking'

export async function persistCart(client, addToCart, cartItems, newItems = []) {
  const cartItemsIfError = cartItems.concat(
    newItems.map(item => ({
      amountToPay: {
        currency_code: '',
        value: '',
      },
      totalAmount: {
        currency_code: '',
        value: '',
      },
      ...item,
    })),
  )

  client.writeData({ data: { cartItems: cartItemsIfError } })

  const { data } = await addToCart({
    variables: {
      cartInfo: { cartItems, newItems },
    },
  })

  localStorage.setItem('cart_id', data.addToCart.cart_id)

  try {
    const { data: _data } = await client.query({
      query: getMayflyData,
      variables: { mfKey: data.addToCart.cart_id },
    })

    const sanitizedCart = _data.getMayflyData
    client.writeData({ data: { cartItems: sanitizedCart } })
    return sanitizedCart
  } catch (err) {
    log({
      file: 'product-page',
      err: { stack: 'Graphql error in addToCart ' + err.message },
    })
    // return what was passed in so that purchase experience will not be blocked
    return cartItemsIfError
  }
}
